<template>
  <div class="video-wrap">
    <span class="close" @click="close">关闭</span>
    <div class="tab-wrap">
<!--      监控实时回放的功能，暂时还未完成 -->
      <div class="tab-content">
        <el-radio-group v-model="currentChoose" size="small" @change="chooseRadioButton($event)">
          <el-radio-button label="online">实时监控</el-radio-button>
          <el-radio-button label="back" v-if="isPlayback">视频回放</el-radio-button>
        </el-radio-group>
      </div>
      <div class="playback-wrap" v-show="currentChoose === 'back'">
        <div class="block">
          <el-date-picker
            @change="chooseBackTime"
            value-format="timestamp"
            size="small"
            v-model="backTime"
            type="datetimerange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期">
          </el-date-picker>
        </div>
      </div>
    </div>
    <div class="video-wrap">
      <video ref="video" controls style="width: 1000px;height: 640px;"></video>
    </div>
  </div>
</template>

<script>
  import Hls from 'hls.js'
  import dayjs from 'dayjs'
  // import * as axios from 'axios'

  export default {
    name: 'my-video',
    data () {
      return {
        deptId: this.$route.query.deptId,
        hls: null,
        currentChoose: 'online',
        backTime: null,
        isMyVideo: false,
        isPlayback:true // true：回放 false：不回放
      }
    },
    props: {
      hlsUrl: {},
      prefixUrl: {},
      md5Value: {},
      cameraId: {},
      tokenValue: {},
      videoLoading: {}
    },
    watch: {
      hlsUrl: {
        deep: true,
        // immediate: true,
        handler (cur) {
          // this.initHlsVideo(this.hlsUrl)
          console.log("1,",this.isMyVideo)
          this.isMyVideo = true
          console.error("myVideo watch,",this.hlsUrl)
          this.initHlsVideo(cur)
        }
      },
      videoLoading: {
        deep: true,
        immediate: true,
        handler (cur) {
          this.videoLoading = cur
        }
      }
    },
    mounted () {
      console.log("myVideo mounted,",this.hlsUrl)
      if (this.hlsUrl) {
        this.initHlsVideo(this.hlsUrl)
      }
      if(this.deptId === 'D18CA078186694D1D84AE02353709E50D'){
        this.isPlayback = false
      }
    },
    methods: {
      initHlsVideo (src) {
        if (Hls.isSupported()) {
          this.hls = new Hls()
          this.hls.loadSource(src)
          this.hls.attachMedia(this.$refs.video)
          this.hls.on(Hls.Events.MANIFEST_PARSED, () => {
            console.log('加载成功', src)
            this.$refs.video.play()
          })
          this.hls.on(Hls.Events.ERROR, (event, data) => {
            if (data.fatal) {
              switch (data.type) {
                case Hls.ErrorTypes.NETWORK_ERROR:
                  // try to recover network error
                  console.log(Hls.ErrorTypes.NETWORK_ERROR, 'fatal network error encountered, try to recover');
                  this.hls.startLoad();
                  break;
                case Hls.ErrorTypes.MEDIA_ERROR:
                  console.log(Hls.ErrorTypes.MEDIA_ERROR,'fatal media error encountered, try to recover');
                  this.hls.recoverMediaError();
                  break;
                default:
                  // cannot recover
                  this.hls.destroy();
                  break;
              }
            }
          })
        } else if (this.$refs.video.canPlayType('application/vnd.apple.mpegurl')) {
          this.$refs.video.src = 'https://video-dev.github.io/streams/x36xhzz/x36xhzz.m3u8'
          this.$refs.video.addEventListener('loadedmetadata', () => {
            this.$refs.video.play()
          })
        }
      },
      close() {
        console.log('myVedio close ,',this.hls)
        if (this.hls) {
          this.$refs.video.pause()
          this.hls.detachMedia(this.$refs.video)
          this.hls.stopLoad()
          this.hls.destroy()
          this.hls = null
          console.log('myVedio close,this.$refs.video',this.$refs.video)
          this.isMyVideo = false
        }
        this.$emit('onClose', false)
      },
      /**
       * @description: 实时监控和视频回放--切换
       * @author: linwen linwen@fjxhx.com
       * @createDate: 2020-10-12 18:05
       * @param: value
       * @return:
      */
      chooseRadioButton(value) {
        /*this.$refs.video.src=''
        this.hls.destroy()
        this.hlsUrl = null*/

        if (this.hls) {
          this.$refs.video.pause()
          this.hls.stopLoad()
          this.hls.destroy()
          this.hls = null
        }

        if (value === 'online') {
          console.log('摄像头实时信息流请求')
          this.$request.cameraStreamGet({ cameraId: this.cameraId}).then(res => {
            console.log('获取摄像头实时信息流', res)
            this.initHlsVideo(res.streamUrl)
          }).catch(e => {
            console.error(e)
          })
        }
        else
        {
          if(this.backTime != null) {
            this.chooseBackTime(this.backTime)
          }
        }
      },
      /**
       * @description: 选择时间后
       * @author: linwen linwen@fjxhx.com
       * @createDate: 2020-10-12 18:15
       * @param: 选择时间后
       * @return:
      */
      chooseBackTime(time) {
        console.error('%%%%%%%%%%%%%%%time%%%%%%%%%%%%%%%%%%', time)
        // this.hls.detachMedia()
        // this.$refs.video.pause()
        // this.hls.destroy()
        // this.hls = null
        this.backTime = time
        this.createPlayBackUrl(time)

      },
      /**
       * @description: 创建 视频回放的播放链接
       * @author: linwen linwen@fjxhx.com
       * @createDate: 2020-10-12 18:18
       * @param: time [Array1, Array2] [开始时间戳, 结束时间戳]
       * @return: url 播放链接
      */
      createPlayBackUrl (time = [Date.now(), Date.now()]) {
        // 播放url的格式要求：
        // http://192.168.254.251:6078/backer/f43a78039cc8e25d12745d467d43017e/hls.m3u8?token=f43a78039cc8e25d12745d467d43017e&st=20200911t093812z&et=20200911t104816z
        let [startTimestamp, endTimestamp] = time
        let params = {
          cameraId: this.cameraId,
          beginDate: dayjs(startTimestamp).format('YYYY-MM-DD'),
          beginTime: dayjs(startTimestamp).format('HH:mm:ss'),
          endDate: dayjs(endTimestamp).format('YYYY-MM-DD'),
          endTime: dayjs(endTimestamp).format('HH:mm:ss')
        }
        console.log('摄像头回放信息流参数', params)
        this.$request.cameraStreamGet(params).then(res => {
          console.log('获取摄像头回放信息流', res)
          if(res.supportPlayBack == 0) {
            this.$alert(res.msg, '摄像头信息', {
              confirmButtonText: '确定',
              center: true
            });
            return
          }
          console.log('播放的url::', res.streamUrl)
          this.initHlsVideo(res.streamUrl)
        }).catch(e => {
          console.error(e)
        })
      }
    },
    beforeDestroy() {
      this.close()
    }
  }
</script>

<style scoped lang="less">
  .video-wrap{
    position: relative;
    width: 1000px;
    height: 670px;
  }
  .close{
    position: absolute;
    right: 10px;
    top: -40px;
    font-size: 16px;
    cursor: pointer;
  }
  .tab-wrap {
    cursor: pointer;
    box-sizing: border-box;
    display: flex;
    justify-content: flex-start;
    align-items: center;

    .tab-item {
      margin: 5px 10px;
      padding: 6px;
      box-shadow: 0px 0px 1px 1px #f5f5f5;;
    }
    .active {
      box-shadow: 0px 0px 2px 2px green;
      transform: scale(1.05);
    }
  }
  .playback-wrap {
    box-sizing: border-box;
    padding: 0px 20px;
    animation: toggle 1s;
  }
  @keyframes toggle {
    0% {
      transform: translateX(100%);
    }
    100% {
      transform: translateX(0%);
    }
  }
  .video-wrap {
    margin: 6px auto;
  }
</style>



// WEBPACK FOOTER //
// src/components/myVideo.vue